import React, {
    useReducer,
    useCallback,
    useEffect,
    useContext,
    memo,
    useMemo,
    useState,
} from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DetailsVehicleCard from 'components/batches/Details/DetailsVehicleCard';
import ManagementList from 'components/batches/Management/ManagementList';
import Traductor from 'components/Traductor';
import ScrollToTop from 'components/ScrollToTop';

import ModalDetailVehicle from 'components/auctions/ModalDetailVehicle';
import DetailsModalOptions from 'components/batches/Details/DetailsPriceForm';

import Header from 'components/batches/closed/Details/Header';
import Summary from 'components/batches/closed/Details/Summary';
import FiltersModal from 'components/batches/closed/Details/FiltersModal';
import Modal from 'components/batches/Details/DetailsModal';

import VehicleService from 'services/VehicleService';
import batchService from 'services/BatchesService';
import Globals from '../Globals';
import { VehiclesContext } from 'contexts/VehiclesContext';
import { UserContext } from 'contexts/UserContext';

import { isAppleDeviceOrNavegatorForDates } from 'Functions';
import { checkAuctionIsActive } from 'js/components/shared/vehicleFunctions';
import { getWSService } from 'js/WebSocketService';
import useServerTime from 'hooks/useServerTime';
import useCustomerId from 'hooks/useCustomerId';
import { makeGetSelectedClosedBatch } from '../redux/selectors/closedBatches';
import * as closedBatchActions from '../redux/actions/closedBatches';
import { filterBrands, filterModels } from 'constants/Filters';

import 'css/components/vehicleFilters/vehicleFilters.css';

import usePermissions from 'hooks/usePermissions';
import { READONLY_PERMISSION } from 'constants/Permissions';

const initialBatchDetailsState = {
    cars: [],
    filters: {
        [filterBrands]: [],
        [filterModels]: [],
    },
    filtersOptions: {},
    showFilters: false,
    selectedVehicle: null,
    amountsForm: {},
    disabled: true,
    directBuyAmount: 0,
    miniumBidAmount: 0,
};

const closedBatchDetailsReducer = (state, { type, payload }) => {
    switch (type) {
        case 'SET_CARS':
            const brands = [];
            const filteredCars = [];

            //BACKEND IS WRONG AND HAS 2 MODELS FOR VEHICLES IN BATCHES THIS MAPS CLOSED BATCHES VEHICLES TO THE SAME FORMAT AS OPEN BATCHES VEHICLES
            const formattedCars = payload.cars
                ? payload.cars.map(
                      ({
                          Brand,
                          Id,
                          VehicleWebSales,
                          Model,
                          Origin,
                          Plate,
                          ImageSource,
                          Kms,
                          CV,
                          Energy,
                          RegistrationDate,
                          Transmission,
                          Frame,
                      }) => {
                          if (!brands.length) {
                              brands.push({
                                  Description: Brand.Description,
                                  Id: Brand.Id,
                                  Models: [
                                      {
                                          Id: Model.Id,
                                          Description: Model.Description,
                                      },
                                  ],
                              });
                          } else {
                              for (let i = 0; i < brands.length; i++) {
                                  if (brands[i].Id === Brand.Id) {
                                      //Update brands[i].Models
                                      if (
                                          !brands[i].Models.some(
                                              e => e.Id === Model.Id
                                          )
                                      ) {
                                          brands[i].Models.push({
                                              Id: Model.Id,
                                              Description: Model.Description,
                                          });
                                          brands[i].Models.sort((a, b) =>
                                              a.Description.localeCompare(
                                                  b.Description
                                              )
                                          );
                                      }
                                      break;
                                  } else if (i === brands.length - 1) {
                                      brands.push({
                                          Description: Brand.Description,
                                          Id: Brand.Id,
                                          Models: [
                                              {
                                                  Id: Model.Id,
                                                  Description:
                                                      Model.Description,
                                              },
                                          ],
                                      });
                                      brands[i].Models.sort((a, b) =>
                                          a.Description.localeCompare(
                                              b.Description
                                          )
                                      );
                                      break;
                                  }
                              }
                          }
                          //BACKEND HAS 2 VEHICLE MODELS AND NEEDS TO BE CHANGED
                          const formattedCar = {
                              AmountReference: VehicleWebSales.RecommendedPrice,
                              Brand,
                              IdVehicle: Id,
                              IdPublish: VehicleWebSales.Id,
                              Model,
                              Origin: Origin.Description,
                              Plate,
                              ImageSource,
                              Km: Kms,
                              CV,
                              Energy: Energy,
                              RegistrationDate: RegistrationDate,
                              Transmission,
                              Frame,
                          };

                          if (state.filters[filterBrands]?.length) {
                              if (
                                  state.filters?.[filterBrands].some(
                                      e => e.Id === Brand.Id
                                  )
                              ) {
                                  if (state.filters?.[filterModels]?.length) {
                                      if (
                                          state.filters[filterModels].some(
                                              e => e.Id === Model.Id
                                          )
                                      ) {
                                          filteredCars.push(formattedCar);
                                      }
                                  } else {
                                      filteredCars.push(formattedCar);
                                  }
                              }
                          } else {
                              filteredCars.push(formattedCar);
                          }
                          return formattedCar;
                      }
                  )
                : [];
            return {
                ...state,
                cars: formattedCars,
                filteredCars,
                filters: { ...state.filters },
                filtersOptions: {
                    Brands: brands,
                },
                amountsForm: payload.form
                    ? payload.form.reduce((acc, [key, value]) => {
                          return { ...acc, [key]: +value };
                      }, {})
                    : formattedCars.reduce((acc, curr) => {
                          return {
                              ...acc,
                              [curr.IdPublish]: curr.AmountOffered
                                  ? curr.AmountOffered
                                  : '',
                          };
                      }, {}),
                disabled: payload.disabled,
                directBuyAmount: payload.directBuyAmount,
                miniumBidAmount: payload.miniumBidAmount,
            };
        case 'SELECT_VEHICLE':
            return { ...state, selectedVehicle: payload };
        case 'UNSELECT_VEHICLE':
            return { ...state, selectedVehicle: null };
        case 'UPDATE_VEHICLE_AMOUNT':
            return {
                ...state,
                amountsForm: {
                    ...state.amountsForm,
                    [payload.IdPublish]: payload.amount.replaceAll('.', ''),
                },
            };
        case 'UPDATE_SELECTED_VEHICLE':
            return {
                ...state,
                selectedVehicle:
                    state.selectedVehicle.IdVehicle === payload.IdVehicle
                        ? payload
                        : state.selectedVehicle,
            };
        case 'SET_STATUS':
            return { ...state, disabled: payload };
        case 'SHOW_FILTERS':
            return { ...state, showFilters: !state.showFilters };
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...initialBatchDetailsState.filters,
                },
                filteredCars: state.cars,
            };
        case 'UPDATE_FILTERS':
            const newState = { ...state };
            if (payload.name === filterBrands) {
                newState.filters = {
                    ...state.filters,
                    [filterBrands]: state.filters[filterBrands]?.length
                        ? []
                        : [payload.data],
                    [filterModels]: [],
                };
                newState.filtersOptions = {
                    ...state.filtersOptions,
                    Models: state.filters[filterBrands]?.length
                        ? []
                        : state.filtersOptions.Brands.find(
                              e => e.Id === payload.data
                          ).Models,
                };
            } else if (payload.name === filterModels) {
                newState.filters = {
                    ...newState.filters,
                    [filterModels]: newState.filters[filterModels].includes(
                        payload.data
                    )
                        ? newState.filters[filterModels].filter(
                              e => e !== payload.data
                          )
                        : [...newState.filters[filterModels], payload.data],
                };
            } else {
                //UPDATE ALL FILTERS OBJECT
                newState.filters = payload.data;
            }
            newState.filteredCars = newState.filters[filterBrands]?.length
                ? state.cars.filter(e => {
                      return newState.filters[filterModels]?.length
                          ? newState.filters[filterBrands].includes(
                                e.Brand.Id
                            ) &&
                                newState.filters[filterModels].includes(
                                    e.Model.Id
                                )
                          : newState.filters[filterBrands].includes(e.Brand.Id);
                  })
                : state.cars;
            return newState;
        default:
            return state;
    }
};

const ClosedBatchDetailsPage = ({
    cookies,
    history,
    match,
    batch,
    activateBatch,
}) => {
    const [
        {
            cars,
            filteredCars,
            selectedVehicle,
            amountsForm,
            disabled,
            directBuyAmount,
            miniumBidAmount,
            filters,
            filtersOptions,
            showFilters,
        },
        dispatch,
    ] = useReducer(closedBatchDetailsReducer, initialBatchDetailsState);
    const { checkPermission } = usePermissions();
    const { setSelectedVehicle } = useContext(VehiclesContext);
    const { serverTime } = useServerTime(true);
    const customerId = useCustomerId();
    const { user } = useContext(UserContext);
    const [errorBatchAdjudicationMessage, setErrorBatchAdjudicationMessage] = useState(false);

    const t = useMemo(() => new Traductor(), []);

    const fetchBatchDetails = useCallback(async () => {
        const token = cookies.get(Globals.COOKIES.JWT)?.AccessToken;
        const {
            body: { Result: cars },
        } = await batchService.getClosedBatchDetails(
            +match.params.value,
            token
        );

        const form = batch.BatchDetail ? JSON.parse(batch.BatchDetail) : null;

        dispatch({
            type: 'SET_CARS',
            payload: {
                cars: cars,
                disabled:
                    checkPermission(READONLY_PERMISSION) ||
                    !checkAuctionIsActive(
                        isAppleDeviceOrNavegatorForDates(batch?.StartDate),
                        isAppleDeviceOrNavegatorForDates(batch?.EndDate),
                        serverTime,
                        batch.upcoming
                    ) ||
                    batch.upcoming ||
                    batch.Sold ||
                    !cars?.length,
                directBuyAmount: cars?.length
                    ? cars[0]?.VehicleWebSales?.Price
                    : 0,
                miniumBidAmount: cars?.length
                    ? cars[0]?.VehicleWebSales?.MinimumPrice
                    : 0,
                form,
            },
        });
    }, [batch, checkPermission, cookies, match.params.value, serverTime]);

    useEffect(() => {
        if (serverTime) {
            fetchBatchDetails();
        }
    }, [serverTime, fetchBatchDetails]);

    const onVehicleCardPress = useCallback(
        vehicle => {
            setSelectedVehicle(vehicle);
            dispatch({ type: 'SELECT_VEHICLE', payload: vehicle });
        },
        [setSelectedVehicle]
    );

    const onChangeAmount = useCallback(
        payload => dispatch({ type: 'UPDATE_VEHICLE_AMOUNT', payload }),
        []
    );

    const onChangeBatchStatus = useCallback(
        payload => dispatch({ type: 'SET_STATUS', payload }),
        []
    );

    const onCountDownEnd = useCallback(
        status => {
            if (batch.upcoming) {
                //move batch from upcoming array to active array
                activateBatch(batch.LotId);
            } else {
                onChangeBatchStatus(status); //countdown status = true -> disable batch
            }
        },
        [activateBatch, batch.LotId, batch.upcoming, onChangeBatchStatus]
    );

    const sendSocketMessage = useCallback(
        type => {
            const message = {
                type,
                data: {
                    Vehicles: [batch.LotId],
                },
                batch: true,
            };
            getWSService().sendMessage('onMessage', message);
        },
        [batch.LotId]
    );

    const onBid = useCallback(
        async (formEntries, total) => {
            const token = cookies.get(Globals.COOKIES.JWT)?.AccessToken;
            const bid = {
                IdVehicle: batch.LotId.toString(), //+match.params.value,
                IdUser: cookies.get(Globals.COOKIES.USER),
                Bid: total.toString(),
                BatchDetail: JSON.stringify(formEntries).toString(),
                BidMax: total.toString(),
                IdPreferenceTransport: '0',
                IdCustomer: customerId.toString(),
            };

            await new VehicleService().insertBid(
                process.env.REACT_APP_AWS_BIDS_URL,
                process.env.REACT_APP_AWS_BIDS_APIKEY_NAME,
                process.env.REACT_APP_AWS_BIDS_APIKEY_VALUE,
                bid,
                token
            );
            //socket message -> refetch amazon amounts
            sendSocketMessage('pujas');
        },
        [cookies, batch.LotId, customerId, sendSocketMessage]
    );

    const onDirectBuy = useCallback(async () => {
        const token = cookies.get(Globals.COOKIES.JWT)?.AccessToken;

        const data = {
            IdBach: batch.LotId,
            IdUserCreate: user?.data?.UserId,
            Name: batch.Name,
            BatchDetail: JSON.stringify(Object.entries(amountsForm)),
        };

        const {
            body: { Result },
        } = await batchService.buyClosedBatch(data, token);

        if (Result) {
            //websocket -> disable batch message -> item.Sold = true
            sendSocketMessage('directPurchase');
        }
        else
        {
            setErrorBatchAdjudicationMessage(true);
        }


    }, [
        amountsForm,
        batch.LotId,
        batch.Name,
        cookies,
        sendSocketMessage,
        user?.data?.UserId,
    ]);

    const renderOptions = useCallback(
        props => (
            <DetailsModalOptions
                inputAmount={amountsForm[selectedVehicle?.IdPublish]}
                onChangeAmount={onChangeAmount}
                containerClasses={'u-mt u-pl-none'}
                disabled={disabled}
                {...props}
            />
        ),
        [amountsForm, selectedVehicle?.IdPublish, onChangeAmount, disabled]
    );

    const renderVehicleCard = useCallback(
        props => (
            <DetailsVehicleCard
                onVehicleCardPress={onVehicleCardPress}
                onChangeAmount={onChangeAmount}
                inputAmount={amountsForm[props?.IdPublish]}
                disabled={disabled}
                {...props}
            />
        ),
        [
            //Do not change on form change in order to keep input focus
            filteredCars,
            disabled,
            onVehicleCardPress,
            onChangeAmount,
            selectedVehicle,
        ]
    );

    return (
        <section
            id="c-batch-details"
            className="o-content-section u-pt-small u-rema-full-height"
            data-testid="closedBatchDetailsPageTestId"
        >
            <ScrollToTop />
            <div className="o-page-wrap o-page-wrap--xsmall o-layout">
                <Header
                    data={batch}
                    dispatch={dispatch}
                    filters={filters}
                    filtersOptions={filtersOptions}
                />
                <ManagementList
                    list={
                        cars?.length
                            ? filteredCars
                            : [
                                  { loading: true },
                                  { loading: true },
                                  { loading: true },
                                  { loading: true },
                              ]
                    }
                    component={renderVehicleCard}
                    valueChanging={0}
                    itemKey={'IdVehicle'}
                    amountToRender={1}
                    extraClasses={{
                        listItemClasses: 'u-pt',
                        listClasses:
                            'o-layout-item u-3/4 u-1/1@s u-inline-item  u-pr u-pr-none@s',
                    }}
                />
                <Summary
                    loading={false}
                    data={batch}
                    amountsForm={amountsForm}
                    disabled={disabled}
                    onCountDownEnd={onCountDownEnd}
                    onBid={onBid}
                    onDirectBuy={onDirectBuy}
                    serverTime={serverTime}
                    directBuyAmount={directBuyAmount}
                    miniumBidAmount={miniumBidAmount}
                />
            </div>
            {selectedVehicle && (
                <ModalDetailVehicle
                    vehicle={selectedVehicle}
                    onShowDetail={() => dispatch({ type: 'UNSELECT_VEHICLE' })}
                    printCountDown={() => null}
                    printFavouriteIcon={() => null}
                    printWebSalesOptions={props => renderOptions(props)}
                    updateVehiclesList={payload =>
                        dispatch({ type: 'UPDATE_SELECTED_VEHICLE', payload })
                    }
                    tagMaxBidStatus={() => null}
                    fetchServerTime={() => null}
                    inactive={false}
                />
            )}
            <Modal
                visible={batch.Sold}
                onActionPress={() =>
                    history.push(Globals.APPLICATION_PATH.HOME)
                }
                title={t.getTraduction('ClosedBatchSoldTitle')(batch?.Name)}
                content={t.getTraduction('ClosedBatchSoldContent')}
                rightButton={t.getTraduction('Accept')}
            />
            <Modal
                visible={errorBatchAdjudicationMessage}
                onActionPress={() =>
                    history.push(Globals.APPLICATION_PATH.HOME)
                }
                title={t.getTraduction('ClosedBatchSoldTitleError')(batch?.Name)}
                content={t.getTraduction('ClosedBatchSoldContentError')}
                rightButton={t.getTraduction('Accept')}
            />
            <FiltersModal
                filters={filters}
                filtersOptions={filtersOptions}
                showFilters={showFilters}
                dispatch={dispatch}
            />
        </section>
    );
};

const makeMapStateToProps = () => {
    const getSelectedClosedBatch = makeGetSelectedClosedBatch();
    const mapStateToProps = (state, props) => {
        return {
            batch: getSelectedClosedBatch(state, props),
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(closedBatchActions, dispatch),
});

export default memo(
    connect(
        makeMapStateToProps,
        mapDispatchToProps
    )(withCookies(ClosedBatchDetailsPage))
);
